import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_FUND_ORDER_STATUS_HISTORIES = 'GET_FUND_ORDER_STATUS_HISTORIES';

const apiCall = createApiCall(
  GET_FUND_ORDER_STATUS_HISTORIES,
  (params: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `api/admin/orders/${params.id}/status-histories`,
      params: {},
    }),
    method: 'GET',
  })
);

export default apiCall;
